import React from 'react';
import { Text } from './text';
import { cs } from '../utils';
import { useNotionContext } from '../context';
import { uuidToId } from '@simpledotink/notion-utils';
export var List = function (_a) {
    var _b, _c;
    var block = _a.block, children = _a.children;
    var recordMap = useNotionContext().recordMap;
    var output = null;
    if (block.content) {
        output = (React.createElement(React.Fragment, null, block.properties && (React.createElement(ListItem, { block: block },
            React.createElement(Text, { value: block.properties.title, block: block }),
            React.createElement(ListContainer, { block: block }, children)))));
    }
    else {
        output = block.properties ? (React.createElement(ListItem, { block: block },
            React.createElement(Text, { value: block.properties.title, block: block }))) : null;
    }
    var isTopLevel = block.type !== ((_c = (_b = recordMap.block[block.parent_id]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.type);
    var start = getListIndex(block, recordMap);
    return isTopLevel ? (React.createElement(ListContainer, { block: block, start: start }, output)) : (output);
};
function ListContainer(_a) {
    var _b;
    var children = _a.children, block = _a.block;
    var color = (_b = block.format) === null || _b === void 0 ? void 0 : _b.block_color;
    var blockId = "notion-block-".concat(uuidToId(block.id));
    return (React.createElement("div", { className: cs('notion-list-custom', blockId, color ? "notion-".concat(color) : '') }, children));
}
function ListItem(_a) {
    var _b;
    var block = _a.block, children = _a.children;
    var recordMap = useNotionContext().recordMap;
    var sn = ((_b = block.format) === null || _b === void 0 ? void 0 : _b.list_start_index) || getListIndex(block, recordMap);
    return (React.createElement("div", { className: 'notion-list-child' },
        React.createElement("div", { className: 'notion-list-child-marker' }, block.type === 'bulleted_list' ? (React.createElement("span", { className: 'disc' }, "\u2022")) : (React.createElement("span", { className: 'numbered' },
            sn,
            "."))),
        React.createElement("div", { className: 'notion-list-child-content' },
            React.createElement("div", null, children))));
}
function getListIndex(block, recordMap) {
    var _a;
    var blocks = Object.keys(recordMap.block)
        .map(function (key) { return recordMap.block[key]; })
        .filter(function (b) { var _a; return ((_a = b === null || b === void 0 ? void 0 : b.value) === null || _a === void 0 ? void 0 : _a.parent_id) == (block === null || block === void 0 ? void 0 : block.parent_id); });
    var indexy = 0;
    for (var i = 0; i < blocks.length; i++) {
        var b = (_a = blocks[i]) === null || _a === void 0 ? void 0 : _a.value;
        if ((b === null || b === void 0 ? void 0 : b.type) == 'sub_header' || (b === null || b === void 0 ? void 0 : b.type) == 'text') {
            indexy = 0;
        }
        else if ((b === null || b === void 0 ? void 0 : b.type) == 'numbered_list') {
            indexy++;
        }
        if ((b === null || b === void 0 ? void 0 : b.id) == (block === null || block === void 0 ? void 0 : block.id)) {
            return indexy;
        }
    }
    return indexy;
}
//# sourceMappingURL=list.js.map